import { useState } from "react";
import restApiService from "../restApiService";
import { useDispatch } from "react-redux";
import { toast } from "../../store/toastSlice";
import { AlertType } from "../../shared/constants/enums";

function usePost() {
  const [data, setData] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const postService = async (url: string, payload: any, message = "") => {
    setLoading(true);
    try {
      const response = await restApiService.post(url, payload);
      setData(response?.data || response?.status);
      setLoading(false);
      dispatch(
        toast({
          isOpen: true,
          message: message || "It has been Saved Successfully.",
          type: AlertType.SUCCESS,
        })
      );
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        (error.code.includes("ERR_NETWORK")
          ? "Connection timed out. Please try again later."
          : "An unexpected error has occurred");
      setData(null);
      setLoading(false);
      setError(errorMessage);
      dispatch(
        toast({
          isOpen: true,
          message: errorMessage,
          type: AlertType.ERROR,
        })
      );
    }
  };
  return { data, loading, error, postService };
}

export default usePost;
